import { tireOrderingTestInstance } from '../axios';

const getCountries = () => tireOrderingTestInstance.post('/sections/countries');

export default getCountries;
